import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { useInstallPrompt, IOSInstallDialog, isStandalone } from "@/components/InstallPrompt";

/** Fixed bottom CTA on the public landing page — triggers the PWA install prompt. Hidden once installed. */
export default function DownloadAppBar() {
  const { install, iosOpen, setIosOpen } = useInstallPrompt();
  const [hidden, setHidden] = useState(() => isStandalone());
  useEffect(() => {
    const onInstalled = () => setHidden(true);
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);
  if (hidden) return null;
  return (
    <>
      <div className="fixed bottom-0 inset-x-0 z-50 p-3 pointer-events-none" data-testid="download-app-bar">
        <button
          type="button"
          onClick={install}
          data-testid="download-app-btn"
          className="pointer-events-auto mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-full px-5 py-3.5 text-[13px] sm:text-base font-extrabold uppercase tracking-wide leading-tight text-white shadow-[0_10px_30px_-10px_rgba(124,58,237,0.7)] transition-transform duration-200 hover:-translate-y-0.5 active:scale-[0.98] animate-pulse-soft"
          style={{ background: "linear-gradient(90deg, #ec4899 0%, #a855f7 55%, #7c3aed 100%)" }}
        >
          <Send className="w-5 h-5 shrink-0 -rotate-12" />
          <span>BAIXE O APLICATIVO DIRETO AQUI NO SITE!</span>
        </button>
      </div>
      <IOSInstallDialog open={iosOpen} onOpenChange={setIosOpen} />
    </>
  );
}
